<script>
import { list } from '@/api/prazo'

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ prazo_descricao: searchValue, qtd, page })
      return result.data
    }
  }
}
</script>

<template>
  <ui-auto-complete-busca
    ref="fieldBusca"
    :model="model"
    field="prazo_descricao"
    width="1000"
    component="app-prazo-grid"
    label="Prazo"
    @change="v => $emit('change', v)"
    :autocomplete="autocomplete" />
</template>
